import { Component } from '@theme/component';

class SnoozeCommercial extends Component {
  requestQuote(event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = this.querySelector('.snooze-commercial__form');
    const name = form?.querySelector('input[name="contact[name]"]');
    if (!(form instanceof HTMLFormElement) || !(name instanceof HTMLInputElement)) return;
    event.preventDefault();
    name.focus({ preventScroll: true });
    form.scrollIntoView({ block: 'start', behavior: 'instant' });
  }
}

if (!customElements.get('snooze-commercial-component')) {
  customElements.define('snooze-commercial-component', SnoozeCommercial);
}
